import React from "react";
import LoadingOverlay from "react-loading-overlay";
import InsuranceInfo from "../../../components/InsuranceInfo";
import { Layout } from "../../../components/Layout";
import "./CarCompanies.scss";
import {
  CButton,
  CInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from "@coreui/react";
import { CryptInfo } from "../../../util/utils";
import CryptoJS from "crypto-js";
import svgLogo from "../../Content/Images/car50percent.svg";
import { withTranslation } from "react-i18next";
import videoIcon from "../../../assets/icons/videoplay.svg";
import Spinner from "../../../components/Spinner";
import { Helmet } from "react-helmet";
import { Box, Typography, Button } from "@material-ui/core";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import Fade from "react-reveal/Fade";

const isMobile = window.innerWidth <= 800;

const ref = React.createRef();

SwiperCore.use([Navigation]);

const slides = [
  "Content/Images/owntic-car-companies-01.png",
  "Content/Images/owntic-testimonial-10.png",
  "Content/Images/owntic-testimonial-15.png",
  "Content/Images/owntic-testimonial-12.png",
  "/Content/Images/owntic-car-companies-12.jpg",
  "Content/Images/owntic-car-companies-11.jpg",
];

class CarCompanies extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userRole: "",
      carCompanies: "",
      user: {},
      openModal1: false,
      openModal2: false,
    };
  }

  componentDidMount() {
    this.getUser();
  }
  getUser = () => {
    try {
      var user = localStorage.getItem("user");
      if (!user) {
        return;
      }
      let secret = CryptInfo.SecretKey.toString();
      var bytes = CryptoJS.AES.decrypt(user, secret);
      var originalText = bytes.toString(CryptoJS.enc.Utf8);
      user = JSON.parse(originalText);
      let userRole = user.logintype;
      this.setState({ userRole: userRole });
      console.log(userRole);
      let shortMail =
        user.email.length > 8 ? user.email.substring(0, 8) + "..." : user.email;
      this.setState({ user: user });
      this.setState({ shortMail: shortMail });
      return shortMail;
    } catch (e) {
      localStorage.clear();
      sessionStorage.clear();
      var cookies = document.cookie.split(";");

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if (name.includes("user")) {
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
      }

      setTimeout(function () {
        window.location.reload();
      }, 100);
    }
  };

  render() {
    const { t } = this.props;
    return (
      <LoadingOverlay active={this.state.isLoaderActive} spinner={<Spinner />}>
        <Layout>
          <Helmet>
            <title>Car dealers, Car rentals, Franchises and Car Brokers</title>
            <meta
              name="description"
              content="Customer comes with the car to rent. We reset inventory cost."
            />
          </Helmet>
          <CModal
            style={{ marginTop: "200px" }}
            alignment="center"
            show={this.state.modal}
            onClose={() => this.setState({ modal: false })}
            color="primary"
          >
            <CModalHeader closeButton>UYARI</CModalHeader>
            <CModalBody style={{ backgroundColor: "#ebedef" }}>
              Bu arama Car Companies içindir!
            </CModalBody>
          </CModal>

          <section className="car-companies-container">
            {/*<div className="car-companies-card">*/}
            {/*    <section className="car-companies-header">*/}
            {/*        <span>*/}
            {/*            <p align="justify">*/}
            {/*                {t("carcompaniesBasYazi1")}<br></br>*/}
            {/*            </p>*/}
            {/*        </span>*/}
            {/*    </section>*/}

            {/*    <section*/}
            {/*        className="car-companies-body"*/}
            {/*    >*/}
            {/*        <div className="search-container">*/}
            {/*            <CInput value={this.state.carCompanies}*/}
            {/*                    onChange={(e) => this.setState({carCompanies: e.target.value})}*/}
            {/*                    type="string" placeholder={t("typeYourCarModel")}/>*/}
            {/*                    type="string" placeholder=fc6912{t("typeYourCarModel")}/>*/}

            {/*            <CButton onClick={() => {*/}
            {/*                if (this.state.userRole === "1" || this.state.userRole === 1) {*/}
            {/*                    this.setState({modal: true})*/}
            {/*                } else if (this.state.userRole === "3" || this.state.userRole === 3) {*/}
            {/*                    localStorage.setItem("carCompanies", this.state.carCompanies)*/}
            {/*                    window.location.href = "/dashboard/Ads"*/}
            {/*                } else {*/}
            {/*                    window.location.href = "/login"*/}
            {/*                }*/}
            {/*            }}>{t("carcompaniesSearchCar")}</CButton>*/}
            {/*        </div>*/}
            {/*    </section>*/}
            {/*</div>*/}
            <Fade bottom distance="20%">
            <div id="6" className="banner">
              <Typography className="subtitleall">
                <span>
                  {t("cCHerotoptitle01")}
                </span>
                {t("cCHerotoptitle02")}
              </Typography>
              <Typography
                style={{ fontWeight: "bold", textAlign: "center" }}
                variant="h2"
              >
                {t("cCtitle01")}
                <br />
                {t("cCtitle02")}
                <br />
                {t("cCtitle03")}
              </Typography>
              {/*<Typography  */}
              {/*variant="body2"*/}
              {/*style={{ textAlign: "center", fontSize: "19px" }}*/}
              {/*className="bottomsubtitle"*/}
              {/*>*/}
              {/*  {t("cCHerosubtitle01")}*/}
              {/*</Typography> */}
              <div style={{ marginBottom: "50px" }}></div>
            </div>

            <div id="6" className="ownticbroker-section ">
              <div className="text-container" style={{ flex: "1 0 50%" }}>
                <Box
                  style={{
                    display: "grid",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <Box style={{ flex: 7 }}>
                    <Typography className="cCtoptitle">
                      {t("cCSection1toptitle01")}
                    </Typography>
                    <Typography style={{ fontWeight: "bold" }} variant="h3">
                      {t("cCSection1title01")}
                      <br />
                      {t("cCSection1title02")}
                      <br />
                      {t("cCSection1title03")}
                      <br />
                    </Typography>
                  </Box>

                  <Typography
                    style={{
                      fontSize: "19px",
                      maxWidth: "550px",
                    }}
                    variant="body2"
                  >
                    {t("cCSection1content01")}
                  </Typography>
                </Box>
                <div style={{ marginBottom: "20px" }}></div>
                <Button
                  onClick={() => window.open("/contact", "_self")}
                  className="home-register-button ob-button"
                  style={{ textTransform: "capitalize", fontWeight: "700" }}
                >
                  {t("getInTouch")}
                </Button>
              </div>
              <div className="imageContainer">
                <div className="map-container">
                  <div className="frame-wrapper">
                    <img
                      src="Content/Images/owntic-car-companies-27.png"
                      className="responsive-image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div id="6" className="ownticbroker-section center-section ">
              <div className="imageContainer">
                <div className="map-container">
                  <div className="frame-wrapper">
                    <img
                      src="Content/Images/owntic-car-companies-34.png"
                      className="responsive-image"
                    />
                  </div>
                </div>
              </div>
              <div className="text-container" style={{ flex: "1 0 40%" }}>
                <Box
                  style={{
                    display: "grid",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <Box style={{ flex: 7 }}>
                    <Typography className="cCtoptitle">
                      {t("cCSection2toptitle01")}
                    </Typography>
                    <Typography style={{ fontWeight: "bold" }} variant="h3">
                      {t("cCSection2title01")}
                      <br className="br" />
                      {t("cCSection2title02")}
                      <br className="br" />
                      {t("cCSection2title03")}
                      <br className="br" />
                    </Typography>
                  </Box>

                  <Typography
                    style={{
                      fontSize: "19px",
                      maxWidth: "550px",
                    }}
                    variant="body2"
                  >
                    {t("cCSection2content01")}
                  </Typography>
                </Box>
                <div style={{ marginBottom: "20px" }}></div>
                <Button
                  onClick={() => window.open("/contact", "_self")}
                  className="home-register-button ob-button"
                >
                  {t("getInTouch")}
                </Button>
              </div>
            </div>

            <div id="6" className="ownticbroker-section ">
              <div className="text-container" style={{ flex: "1 0 50%" }}>
                <Box
                  style={{
                    display: "grid",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <Box style={{ flex: 7 }}>
                    <Typography className="cCtoptitle">
                      {t("cCSection3toptitle01")}
                    </Typography>
                    <Typography style={{ fontWeight: "bold" }} variant="h3">
                      {t("cCSection3title01")}
                      <br />
                      {t("cCSection3title02")}
                      <br />
                      {t("cCSection3title03")}
                      <br />
                    </Typography>
                  </Box>

                  <Typography
                    style={{
                      fontSize: "19px",
                      maxWidth: "550px",
                    }}
                    variant="body2"
                  >
                    {t("cCSection3content01")}
                  </Typography>
                </Box>
                <div style={{ marginBottom: "20px" }}></div>
                <Button
                  onClick={() => window.open("/contact", "_self")}
                  className="home-register-button ob-button"
                  style={{ textTransform: "capitalize", fontWeight: "700" }}
                >
                  {t("getInTouch")}
                </Button>
              </div>
              <div className="imageContainer">
                <div className="map-container">
                  <div className="frame-wrapper">
                    <img
                      src="Content/Images/owntic-car-companies-13.png"
                      className="responsive-image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div id="6" className="owtic-slider">
              <Box
                style={{
                  display: "grid",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Box style={{ flex: 7 }}>
                  <Typography className="cCtoptitle">
                    {t("cCGallerytoptitle")}
                  </Typography>
                  <Typography
                    style={{ fontWeight: "bold", textAlign: "center" }}
                    variant="h3"
                  >
                    {t("cCGallerytitle")}
                  </Typography>
                  <Typography
                    variant="body2"
                    className="bottomsubtitle"
                    style={{ textAlign: "center", fontSize: "19px" }}
                  >
                    {t("cCGallerysubtitle")}
                  </Typography>
                </Box>
              </Box>

              <Swiper
                pagination
                navigation
                style={{
                  height: "fit-content",
                  marginTop: "50px",
                }}
                className="swiperslide swipper-wrapper-mobile"
                spaceBetween={10}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  600: {
                    slidesPerView: 3,
                  },
                }}
                // centeredSlides
                onSwiper={(swiper) => console.log(swiper)}
              >
                {slides.map((slide) => (
                  <SwiperSlide
                    style={{
                      width: "70%",
                      display: "flex",
                    }}
                  >
                    <img className="responsive-image" src={slide} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            </Fade>
            <InsuranceInfo />
                    <div class="owntic-announcement">
                        <h1 class="first-line">
                            <span class="highlight-orange">{t("free240Line1a")}</span>{t("free240Line1b")}<br></br>
                            {t("free240Line2")}
                        </h1>
                        <p class="second-line">
                            {t("free240Line3")}<br></br>
                            {t("free240Line4")}
                        </p>


                        <div style={{ marginBottom: "40px" }}></div>
                        <div className="map-container" style={{ marginBottom: "5%", display: "flex", justifyContent: "center" }}>
                            <div className="frame-wrapper">
                                <img
                                    src="Content/Images/owntic-smartcar2.png"
                                    style={{ width: "auto", height: "auto", maxWidth: "100%", maxHeight: "100%" }}
                                    alt="Owntic Smartcar"
                                />
                            </div>
                        </div>
                    </div>

          </section>

          {/*<div id="register" className="register_footer">*/}
          {/*    <div className="container">*/}
          {/*        <div class="text-center"><img class="w-75" src="Content/Images/login-desk.svg" /></div>*/}
          {/*        <label class="pl-md-5">*/}
          {/*         */}
          {/*            <br />*/}
          {/*            <label>{t("home93-1")}</label>*/}

          {/*            <div > <center><a href="/login">{t("home94")}</a></center></div>*/}
          {/*        </label>*/}

          {/*     */}
          {/*    </div>*/}
          {/*</div>*/}
        </Layout>
      </LoadingOverlay>
    );
  }
}

export default withTranslation()(CarCompanies);
